/* States:
 * === State 1. closed ===
 * <div className={"collapse"}   style={{"visibility": "hidden", "position": "absolute", "display": "block"}} /> –> needed for calculation of the height
 *
 * === State 2. click –> opening ===
 * <div className={"collapsing"} style={} />
 * <div className={"collapsing"} style={{height: "500px"}} /> –> height must be set after className is set
 *
 * === State 3. opened ===
 * <div className={"collapse show"} style={{"height": "500px"}} />
 *
 * === State 4. click –> closing ===
 * <div className={"collapsing"} style={{"height": "500px"}} />
 * <div className={"collapsing"} style={} />
 */
// import { Collapse } from 'bootstrap';
import { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

import delay from 'functions/delay';

export function useCollapsibleHook(isInitialyOpen: boolean) {
	const collapseTime: number = 350; // .35s
	const ref = useRef<HTMLInputElement | null>(null);
	const [isOpen, setIsOpen] = useState<boolean>(isInitialyOpen ?? false);
	const [transitionDone, setTransitionDone] = useState<boolean>(true);

	const [className, setClassName] = useState<string>(getInitialClassName(isOpen));
	const [style, setStyle] = useState<React.CSSProperties | undefined>(undefined);
	const [height, setHeight] = useState<number | null>(null);

	async function toggleIsOpen() {
		setIsOpen(!isOpen);
	}

	useEffect(() => {
		const newHeight: number | null = ref.current?.getBoundingClientRect().height ?? null;
		if (newHeight !== null && newHeight > 0) {
			if (height === null && isOpen) {
				setStyle({
					height: newHeight + 'px',
				});
			}
			setHeight(newHeight);
		}
	}, [ref.current?.getBoundingClientRect().height]);

	async function handleToggle() {
		const showAdvancedSearch = isOpen;
		setTransitionDone(false);
		toggleIsOpen();
		if (showAdvancedSearch === false) {
			setClassName('collapsing');
			await delay(collapseTime);
			setClassName('collapse show');
		}
		if (showAdvancedSearch === true) {
			setClassName('collapsing');
			await delay(collapseTime);
			setClassName('collapse');
		}
		setTransitionDone(true);
	}

	useEffect(() => {
		const f = async () => {
			if (height === null) {
				// init
				if (!isOpen) {
					setStyle({
						visibility: 'hidden',
						position: 'absolute',
						display: 'block',
					});
				}
				return;
			}
			if (isOpen) {
				setStyle({
					height: height + 'px',
				});
			} else {
				setStyle({
					height: undefined,
				});
				await delay(collapseTime);
				setStyle({
					visibility: 'hidden',
					position: 'absolute',
					display: 'block',
				});
			}
		};
		f();
	}, [className]);

	function getInitialClassName(searchIsShown: boolean): string {
		if (searchIsShown) return 'collapse show';
		return 'collapse';
	}

	return {
		isOpen: isOpen && transitionDone,
		style: style,
		className: className,
		ref: ref,
		handleToggle: handleToggle,
	};
}

// export function useCollapsibleBootstrap(isInitialyOpen: boolean) {
// 	const ref = useRef<HTMLInputElement | null>(null);
// 	const [collapse, setCollapse] = useState<Collapse | null>(null);
// 	const [isOpen, setIsOpen] = useState<boolean>(isInitialyOpen ?? false);
//
// 	useEffect(() => {
// 		initialize();
// 	}, [ref]);
//
// 	function toggleIsOpen() {
// 		setIsOpen(!isOpen);
// 	}
//
// 	function initialize() {
// 		if (!ref.current) return;
// 		if (collapse) return;
// 		const bsCollapse = new Collapse(ref.current, {
// 			toggle: isOpen,
// 		});
// 		setCollapse(bsCollapse);
// 	}
//
// 	async function handleToggle() {
// 		if (!collapse) return;
// 		if (isOpen) collapse.hide();
// 		if (!isOpen) collapse.show();
// 		await delay(350);
// 		toggleIsOpen();
// 	}
//
// 	return {
// 		ref: ref,
// 		handleToggle: handleToggle,
// 		isOpen: isOpen,
// 	};
// }
